import { Button, Modal, ModalBody, ModalFooter, Typography } from '@coolblue-development/freddy';
import { FC, ReactNode, useEffect, useState } from 'react';
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';
import { MovedBackground } from './MovedBackground';
import { datadogLogs } from '@datadog/browser-logs';
import { initializeDatadog } from '../../utils/initializeDatadog';

export const NewUrlPopup: FC<{ children: ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(true);
  useCopyToClipboard();

  useEffect(() => {
    // Datadog is normally initialized by App, which isn't mounted while the
    // popup is shown, so ensure it's ready before logging.
    initializeDatadog();
    datadogLogs.logger.info('cato_has_moved_popup_shown');
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent): void => {
      // Ctrl/Cmd+Shift+K to dismiss
      if (e.key.toLowerCase() === 'k' && (e.metaKey || e.ctrlKey) && e.shiftKey && open) {
        e.preventDefault();
        setOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  if (!open) return children;

  return (
    <>
      <MovedBackground />
      <Modal
        translations={{ ariaLabelClose: 'Close' }}
        title={'Cato has moved!'}
        open={open}
        size="small"
        placement="center"
        onClose={() => {}}
        // Prevent regular users from closing the modal
        sx={{ '[aria-label="Close"]': { display: 'none' } }}
        body={
          <ModalBody>
            <Typography>
              From now on you'll find Cato at a new URL. Go to MyApps and use the new URL, and wave goodbye to this one.
              It's the same old Cato, just in a new place.
            </Typography>
          </ModalBody>
        }
        footer={
          <ModalFooter>
            <Button
              component="a"
              href={'https://myapplications.microsoft.com/'}
              rel="noopener noreferrer"
              onClick={() => datadogLogs.logger.info('cato_has_moved_popup_button_clicked')}
            >
              Go to MyApps
            </Button>
          </ModalFooter>
        }
      />
    </>
  );
};
